<style>
	@import '@/assets/css/custom.css';
	
	.hover-bg-light:hover {
		background-color: #f8f9fa !important;
	}
	
	.cursor-pointer {
		cursor: pointer;
	}
</style>

<template>
    <div>
        <Breadcrumbs main="Service Management" title="Complaint Details" />
         
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            
                            <div class="row mb-3">
                                <div class="col-10">
                                    <!-- If status = 2 -->
                                    <button class="btn btn-info" v-if="service.status != 3" @click="updateStatus()">Update Status</button>
                                    <button class="btn btn-secondary ms-2" v-if="service.status === 1 || service.status === 2" @click="assignToDealer()">Assign to Dealer</button>
                                </div>

                                <div class="col-2">
                                    <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>

                                </div>
                            </div>

                            <div class="row">

                                <div class="col-12">
                                    <div header-class="bg-transparent border-light" class="border border-light">
                                        <h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
                                            Job Details
                                        </h4>

                                        <div class="table table-responsive">
                                            <table class="details-table table-nowrap mb-0">
                                                <tbody>

                                                    <tr width="50%">
                                                        <th scope="row">IMEI</th>
                                                        <th>:</th>
                                                       <td>{{ service.device?.imei }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Vehicle Number</th>
                                                        <th>:</th>
                                                        <td>{{service.vehicle_no}}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Contact</th>
                                                        <th>:</th>
                                                        <td>{{service.mobile}}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Complaint Type</th>
                                                        <th>:</th>
                                                        <td><b>{{service.service_type == 1 ? 'SIM Change' : service.service_type == 2 ? 'Repair' : service.service_type == 3 ? 'Replacement' : service.service_type == 4 ? 'No Data' : service.service_type == 5 ? 'Tracking Issue' : service.service_type == 6 ? 'Hardware Issue' : service.service_type == 7 ? 'Software Issue' : service.service_type == 8 ? 'Alert Fail' : service.service_type == 9 ? 'Other' : service.service_type == 10 ? 'Renewal Replacement' : 'N/A'}}</b></td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Details</th>
                                                        <th>:</th>
                                                        <td>{{service.details}}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Status</th>
                                                        <th>:</th>
                                                        <td>
                                                            <span v-if="service.status == 1">
                                                                <span class="badge rounded-pill bg-warning">Pending</span>
                                                            </span>
                                                            <span v-if="service.status == 2">
                                                                <span class="badge rounded-pill bg-info">Ongoing</span>
                                                            </span>
                                                            <span v-if="service.status == 3">
                                                                <span class="badge rounded-pill bg-success">Completed</span>
                                                            </span>
                                                            <span v-if="service.status == 4">
                                                                <span class="badge rounded-pill bg-info">To Vendor</span>
                                                            </span>
                                                            <span v-if="service.status == 5">
                                                                <span class="badge rounded-pill bg-primary">Component Replaced</span>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">Added By</th>
                                                        <th>:</th>
                                                        <td>{{service.added_user_name}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div> 
                            </div>

                            <div class="row">
                                <div class="col-lg-12 col-md-12 mt-3">
                                    <div header-class="bg-transparent border-light" class="border border-light">
                                        <h4 class="font-size-16 bg-primary border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
                                            Work Logs
                                        </h4>

                                        <div class="table-responsive product-table">
                                            <table class="display" id="complaint-work-logs">
                                                <thead>
                                                    <tr align="center">
                                                        <th>Sl.No</th>
                                                        <th>Date</th>
                                                        <th>Staff</th>
                                                        <th>Status</th>
                                                        <th>Remarks</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="Boolean(work_logs.length)">
                                                    <tr align="center" v-for="(log, index) in work_logs" :key="log.id">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ log.date ? $filters.formatDate(log.date) : '-' }}</td>
                                                        <td>{{ log.done_by_name || '-' }}</td>
                                                        <td>
                                                            <span class="badge rounded-pill bg-warning" v-if="log.status == 1">Pending</span>
                                                            <span class="badge rounded-pill bg-info" v-else-if="log.status == 2">Ongoing</span>
                                                            <span class="badge rounded-pill bg-success" v-else-if="log.status == 3">Completed</span>
                                                            <span class="badge rounded-pill bg-info" v-else-if="log.status == 4">Assigned to vendor</span>
                                                            <span class="badge rounded-pill bg-primary" v-else-if="log.status == 5">Component Replaced</span>
                                                            <span class="badge rounded-pill bg-light" v-else-if="log.status == 6">SIM Change</span>
                                                            <span class="badge rounded-pill bg-secondary" v-else-if="log.status == 7">Device Replaced</span>
                                                            <span class="badge rounded-pill bg-danger" v-else-if="log.status == 8">Renewal Replacement Device Received</span>
                                                            <span class="badge rounded-pill bg-secondary" v-else>{{ log.status }}</span>
                                                        </td>
                                                        <td>{{ log.remarks || '-' }}</td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td colspan="5" align="center">No logs available</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="submitStatusUpdate" enctype="multipart/form-data">
					<div class="row">
                        <div class="col-md-12 form-group">
                            <label class="control-label">Select Status<span class="text-danger">*</span></label>
                        	<select class="form-select" v-model="status_type" @change="onStatusTypeChange">
								<option value="">--Select--</option>
								<option value="1">Component Update</option>
								<option value="2">To Manufacturer</option>
                                <option value="3">SIM Change</option>
                                <option value="4">Completed</option>
                                <option value="5">Replace device</option>
							</select>
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="status_type == 2">
                            <label class="control-label">Choose Vendor<span class="text-danger">*</span></label>
                        	<select class="form-select" v-model="vendor_id">
                                <option value="">--Select Vendor--</option>
                                <option v-for="vendor in vendors" :key="vendor.id" :value="vendor.id">
                                    {{ vendor.name }}
                                </option>
                            </select>

                        </div>
                        
                        <!-- Component Update - Multiple Materials Section -->
                        <div class="col-md-12 mt-2" v-if="status_type == 1">
                            <div v-for="(material, index) in componentMaterials" :key="index" class="mb-3 p-3 border rounded">
                                <div class="row g-2">
                                    <div class="col-md-7 col-12 form-group">
                                        <label class="control-label">Material<span class="text-danger">*</span></label>
                                        <div class="position-relative">
                                            <input 
                                                v-model="material.search" 
                                                class="form-control" 
                                                placeholder="Search material by name or description..."
                                                @input="searchMaterial(index)"
                                                @focus="material.showSuggestions = true"
                                                @blur="hideMaterialSuggestions(index)"
                                                required
                                            />
                                            <div v-if="material.showSuggestions && material.filteredList.length > 0" class="position-absolute w-100 bg-white border rounded shadow-sm" style="z-index: 1000; max-height: 200px; overflow-y: auto; margin-top: 2px;">
                                                <div 
                                                    v-for="mat in material.filteredList" 
                                                    :key="mat.id"
                                                    class="p-2 border-bottom cursor-pointer hover-bg-light"
                                                    @click="selectMaterial(index, mat)"
                                                    style="cursor: pointer;"
                                                >
                                                    <div class="fw-bold">{{ mat.raw_material_name }}</div>
                                                    <small class="text-muted">{{ mat.description }}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="material.selectedMaterial" class="mt-2">
                                            <small class="text-success">
                                                <i class="icofont icofont-check-circled me-1"></i>
                                                Selected: <strong>{{ material.selectedMaterial.raw_material_name }}</strong>
                                            </small>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-8 form-group">
                                        <label class="control-label">Quantity<span class="text-danger">*</span></label>
                                        <input 
                                            class="form-control" 
                                            type="number" 
                                            min="1" 
                                            placeholder="Qty" 
                                            v-model.number="material.qty"
                                            required
                                        />
                                    </div>
                                    <div class="col-md-2 col-4 form-group d-flex align-items-end" v-if="componentMaterials.length > 1">
                                        <button 
                                            type="button" 
                                            class="btn btn-danger btn-sm w-100" 
                                            @click="removeMaterial(index)"
                                            title="Remove Material"
                                        >
                                            <i class="icofont icofont-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 form-group">
                                <button 
                                    type="button" 
                                    class="btn btn-secondary btn-sm" 
                                    @click="addMaterial"
                                >
                                    <i class="icofont icofont-plus me-1"></i> Add More Material
                                </button>
                            </div>
                        </div>

                        <!-- Completed: same flow as recharge.vue — payment status first, then payer, then method -->
                        <div class="col-md-12 form-group mt-2" v-if="status_type == 4">
                            <label class="control-label">Payment Status<span class="text-danger">*</span></label>
                            <select class="form-select" v-model="payment_status" @change="onCompletedPaymentStatusChange">
                                <option value="">--Select Payment Status--</option>
                                <option value="1">Received</option>
                                <option value="2">Not Received</option>
                                <option value="4">Free Service</option>
                                <option value="5">Advance</option>
                            </select>
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="status_type == 4 && payment_status === '4'">
                            <label class="control-label">Remarks</label>
                            <textarea class="form-control" placeholder="Optional remarks" v-model="remarks"></textarea>
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="status_type == 4 && payment_status && payment_status !== '4'">
                            <label class="control-label">Total Amount<span class="text-danger">*</span></label>
                            <input class="form-control" type="number" step="0.01" min="0" placeholder="Enter total amount" v-model="cost"/>
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="status_type == 4 && payment_status && payment_status !== '4'">
                            <label class="control-label">Remarks<span class="text-danger">*</span></label>
                            <textarea class="form-control" placeholder="Enter remarks" v-model="remarks"></textarea>
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="status_type == 4 && payment_status && payment_status !== '4'">
                            <label class="control-label">Payment By<span class="text-danger">*</span></label>
                            <select class="form-select" v-model="payment_by" @change="onCompletedPaymentByChange">
                                <option value="">--Select Payment By--</option>
                                <option value="1">Dealer</option>
                                <option value="2">Customer</option>
                            </select>
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="status_type == 4 && payment_status && payment_status !== '4' && payment_by == '1'">
                            <label class="control-label">Payment Dealer<span class="text-danger">*</span></label>
                            <div class="position-relative">
                                <input
                                    class="form-control"
                                    type="text"
                                    placeholder="Search dealer..."
                                    v-model="paymentDealerSearch"
                                    @input="searchPaymentDealer"
                                    @focus="showPaymentDealerSuggestions = true"
                                    @blur="hidePaymentDealerSuggestions"
                                    autocomplete="off"
                                />
                                <ul
                                    v-if="showPaymentDealerSuggestions && filteredPaymentDealers.length"
                                    class="list-group position-absolute w-100"
                                    style="z-index: 10; max-height: 200px; overflow-y: auto;"
                                >
                                    <li
                                        v-for="dealer in filteredPaymentDealers"
                                        :key="dealer.id"
                                        class="list-group-item list-group-item-action"
                                        @mousedown.prevent="selectPaymentDealer(dealer)"
                                    >
                                        {{ dealer.first_name }}
                                    </li>
                                </ul>
                            </div>
                            <div v-if="selectedPaymentDealer" class="mt-2">
                                <small class="text-success">
                                    <i class="icofont icofont-check-circled me-1"></i>
                                    Selected: <strong>{{ selectedPaymentDealer.first_name }}</strong>
                                </small>
                            </div>
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="status_type == 4 && payment_status && payment_status !== '4' && payment_by == '2'">
                            <label class="control-label">Customer<span class="text-danger">*</span></label>
                            <div class="position-relative">
                                <input
                                    class="form-control"
                                    type="text"
                                    placeholder="Search customer..."
                                    v-model="paymentCustomerSearch"
                                    @input="searchPaymentCustomer"
                                    @focus="showPaymentCustomerSuggestions = true"
                                    @blur="hidePaymentCustomerSuggestions"
                                    autocomplete="off"
                                />
                                <ul
                                    v-if="showPaymentCustomerSuggestions && filteredPaymentCustomers.length"
                                    class="list-group position-absolute w-100"
                                    style="z-index: 10; max-height: 200px; overflow-y: auto;"
                                >
                                    <li
                                        v-for="cust in filteredPaymentCustomers"
                                        :key="cust.id"
                                        class="list-group-item list-group-item-action"
                                        @mousedown.prevent="selectPaymentCustomer(cust)"
                                    >
                                        {{ cust.company_name }}
                                    </li>
                                </ul>
                            </div>
                            <div v-if="selectedPaymentCustomer" class="mt-2">
                                <small class="text-success">
                                    <i class="icofont icofont-check-circled me-1"></i>
                                    Selected: <strong>{{ selectedPaymentCustomer.company_name }}</strong>
                                </small>
                            </div>
                        </div>

                        <!-- Not Received: optional deduct from credit -->
                        <div class="col-md-12 form-group mt-2" v-if="status_type == 4 && payment_user_id && payment_status === '2'">
                            <div class="form-check">
                                <input
                                    id="deduct_from_credit_complaint"
                                    class="form-check-input"
                                    type="checkbox"
                                    v-model="deduct_from_credit"
                                />
                                <label class="form-check-label" for="deduct_from_credit_complaint">
                                    Deduct from advance amount
                                </label>
                            </div>
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="status_type == 4 && payment_user_id && showCompletedPaymentCredit">
                            <label class="control-label">Amount from advance<span class="text-danger">*</span></label>
                            <input
                                class="form-control"
                                type="number"
                                step="0.01"
                                min="0"
                                placeholder="Enter advance amount"
                                v-model="amount_from_credit"
                            />
                            <div v-if="userCreditLoading" class="mt-2">
                                <small class="text-success">Loading...</small>
                            </div>
                            <div v-else-if="userCredit && userCredit.credit_available_amount != null" class="mt-2">
                                <small class="text-success">Advance available: ₹{{ userCredit.credit_available_amount }}</small>
                            </div>
                            <div v-else class="mt-2">
                                <small class="text-muted">-</small>
                            </div>
                            <div v-if="userCreditError" class="text-danger small mt-1">{{ userCreditError }}</div>
                        </div>

                        <!-- Received: payment date, then payment type + cash/online -->
                        <div class="col-md-12 form-group mt-2" v-if="status_type == 4 && payment_status === '1'">
                            <label class="control-label">Payment Date<span class="text-danger">*</span></label>
                            <input class="form-control" type="date" v-model="payment_date" />
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="status_type == 4 && payment_user_id && payment_status === '1'">
                            <label class="control-label">Payment Type<span class="text-danger">*</span></label>
                            <select class="form-select" v-model="payment_type" @change="onCompletedPaymentTypeChange">
                                <option value="">--Select Payment Type--</option>
                                <option value="1">Cash</option>
                                <option value="2">Online</option>
                                <option value="3">Both</option>
                                <option value="4">Advance</option>
                            </select>
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="status_type == 4 && payment_user_id && payment_status === '1' && (payment_type == '2' || payment_type == '3')">
                            <label class="control-label">Select Bank<span class="text-danger">*</span></label>
                            <select class="form-select" v-model="bank_account_id">
                                <option value="">--Select Bank--</option>
                                <option v-for="bank in banks" :key="bank.id" :value="bank.id">
                                    {{ bank.bank_name }} ({{ bank.account_number }})
                                </option>
                            </select>
                        </div>

                        <div class="row" v-if="status_type == 4 && payment_user_id && payment_status === '1' && (payment_type == '2' || payment_type == '3')">
                            <div class="col-md-6 form-group mt-2">
                                <label class="control-label">Online Amount<span class="text-danger">*</span></label>
                                <input class="form-control" type="number" step="0.01" min="0" placeholder="Enter online amount" v-model="online_amount"/>
                            </div>
                            <div class="col-md-6 form-group mt-2">
                                <label class="control-label">Payment ID<span class="text-danger">*</span></label>
                                <input class="form-control" type="text" placeholder="Enter payment ID" v-model="payment_id"/>
                            </div>
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="status_type == 4 && payment_user_id && payment_status === '1' && (payment_type == '1' || payment_type == '3')">
                            <label class="control-label">Cash Amount<span class="text-danger">*</span></label>
                            <input class="form-control" type="number" step="0.01" min="0" placeholder="Enter cash amount" v-model="cash_amount"/>
                        </div>

                        <div class="col-md-12 mt-2" v-if="status_type == 4 && payment_user_id && payment_status === '1' && payment_type && payment_type !== '4' && getPaymentBreakdown()">
                            <div class="card border-light">
                                <div class="card-body p-2">
                                    <div class="row text-center">
                                        <div class="col-md-3">
                                            <small class="text-muted">Total Amount</small>
                                            <div class="fw-bold">₹{{ getPaymentBreakdown().total }}</div>
                                        </div>
                                        <div class="col-md-3" v-if="payment_type === '2' || payment_type === '3'">
                                            <small class="text-muted">Online</small>
                                            <div class="fw-bold">₹{{ getPaymentBreakdown().online }}</div>
                                        </div>
                                        <div class="col-md-3" v-if="payment_type === '1' || payment_type === '3'">
                                            <small class="text-muted">Cash</small>
                                            <div class="fw-bold">₹{{ getPaymentBreakdown().cash }}</div>
                                        </div>
                                        <div class="col-md-3">
                                            <small class="text-muted">Status</small>
                                            <div class="fw-bold" :class="getPaymentBreakdown().statusClass">
                                                {{ getPaymentBreakdown().statusLabel }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- SIM Change ICCID Search -->
                        <div class="col-md-12 form-group mt-2" v-if="status_type == 3">
                            <div class="form-check">
                                <input
                                    id="continueCurrentIccidDetails"
                                    class="form-check-input"
                                    type="checkbox"
                                    v-model="continue_with_current_iccid"
                                    @change="onContinueCurrentIccidChange"
                                />
                                <label class="form-check-label" for="continueCurrentIccidDetails">
                                    Continue with current iccid
                                </label>
                            </div>
                            <div v-if="sim_change_status == 2 && current_sim_iccid" class="mt-1">
                                <span><b>Current ICCID:</b> {{ current_sim_iccid }}</span>
                            </div>
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="status_type == 3 && sim_change_status == 1">
                            <label class="control-label">Select ICCID<span class="text-danger">*</span></label>
                            <div class="position-relative">
                                <input 
                                    v-model="iccid_search" 
                                    class="form-control" 
                                    placeholder="Search ICCID..."
                                    @input="searchIccid"
                                    @focus="showIccidSuggestions = true"
                                    @blur="hideIccidSuggestions"
                                    required
                                />
                                <div v-if="showIccidSuggestions && filteredIccidList.length > 0" class="position-absolute w-100 bg-white border rounded shadow-sm" style="z-index: 1000; max-height: 200px; overflow-y: auto;">
                                    <div 
                                        v-for="iccid in filteredIccidList" 
                                        :key="iccid.id"
                                        class="p-2 border-bottom cursor-pointer hover-bg-light"
                                        @click="selectIccid(iccid)"
                                        style="cursor: pointer;"
                                    >
                                        {{ iccid.iccid }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- SIM Information Display -->
                        <div class="col-md-6 form-group mt-2" v-if="status_type == 3 && sim_change_status == 1 && selectedIccid">
                            <label class="control-label">SIM 1<span class="text-danger">*</span></label>
                            <input v-model="selectedIccid.msisdn_1" class="form-control" disabled/>
                        </div>
                        <div class="col-md-6 form-group mt-2" v-if="status_type == 3 && sim_change_status == 1 && selectedIccid">
                            <label class="control-label">SIM 2<span class="text-danger">*</span></label>
                            <input v-model="selectedIccid.msisdn_2" class="form-control" disabled/>
                        </div>
                        <div class="col-md-12 form-group mt-2" v-if="status_type == 3">
                            <label class="control-label">Year Of Expiry<span class="text-danger">*</span></label>
                            <select class="form-select" v-model="certificate_validity">
                                <option value="">--select--</option>
                                <option value="1">1 Year</option>
                                <option value="2">2 Year</option>
                            </select>
                        </div>
                        <div class="col-md-12 form-group mt-2" v-if="status_type == 3">
                            <label class="control-label">Remarks <span v-if="sim_change_status == 2" class="text-danger">*</span></label>
                            <textarea class="form-control" placeholder="Enter remarks" v-model="sim_change_remarks"></textarea>
                        </div>

                        <!-- Replace Device -->
                        <div class="col-md-12 form-group mt-2" v-if="status_type == 5">
                            <label class="control-label">Current IMEI</label>
                            <input class="form-control" type="text" :value="current_device_imei" disabled/>
                        </div>
                        <div class="col-md-12 form-group mt-2" v-if="status_type == 5">
                            <label class="control-label">New IMEI<span class="text-danger">*</span></label>
                            <div class="position-relative">
                                <input
                                    class="form-control"
                                    type="text"
                                    placeholder="Search IMEI..."
                                    v-model="newImeiSearch"
                                    @input="searchNewImei"
                                    @focus="onNewImeiFocus"
                                    @blur="hideNewImeiSuggestions"
                                    autocomplete="off"
                                />
                                <ul
                                    v-if="showNewImeiSuggestions && filteredDisallocatedDevices.length"
                                    class="list-group position-absolute w-100"
                                    style="z-index: 1056; max-height: 200px; overflow-y: auto;"
                                >
                                    <li
                                        v-for="device in filteredDisallocatedDevices"
                                        :key="device.id"
                                        class="list-group-item list-group-item-action"
                                        @mousedown.prevent="selectNewImei(device)"
                                    >
                                        <span class="fw-bold">{{ device.imei }}</span>
                                        <small class="text-muted d-block" v-if="device.iccid">ICCID: {{ device.iccid }}</small>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="selectedNewImei" class="mt-2">
                                <small class="text-success">
                                    <i class="icofont icofont-check-circled me-1"></i>
                                    Selected: <strong>{{ selectedNewImei.imei }}</strong>
                                </small>
                            </div>
                        </div>
                        <div class="col-md-12 form-group mt-2" v-if="status_type == 5">
                            <label class="control-label">Remarks</label>
                            <textarea class="form-control" placeholder="Enter remarks" v-model="replace_device_remarks"></textarea>
                        </div>
                    </div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" :disabled="isSubmitting">
							<span v-if="isSubmitting">
								<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
								Submitting...
							</span>
							<span v-else>{{ button_title }}</span>
						</button>
						<button class="btn btn-light" type="button" @click="closeModal()" :disabled="isSubmitting">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

		<!-- Dealer Assignment Modal -->
		<div class="modal fade" id="dealerModal" tabindex="-1" aria-labelledby="dealerModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="dealerModalLabel">{{ dealer_modal_title }}</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="" enctype="multipart/form-data">
							<div class="row">
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">Select Dealer<span class="text-danger">*</span></label>
									<select class="form-select" v-model="selected_dealer_id">
										<option value="">--Select Dealer--</option>
										<option v-for="dealer in dealers" :key="dealer.id" :value="dealer.id">
											{{ dealer.first_name }}
										</option>
									</select>
								</div>
							</div>
						</form>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary" @click="submitDealerAssignment">Assign to Dealer</button>
						<button type="button" class="btn btn-light" @click="closeDealerModal()">Close</button>
					</div>
				</div>
			</div>
		</div>

    </div>	
</template>

<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;
	let dealerModal;


   export default {
		name: "Job Details",
        components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
				dealerModal = new Modal(document.getElementById('dealerModal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			const showDealerModal = () => {
				if (dealerModal) {
					dealerModal.show();
				} else {
					dealerModal = new Modal(document.getElementById('dealerModal'));
					dealerModal.show();
				}
			}

			const hideDealerModal = () => {
				if (dealerModal) {
					dealerModal.hide();
				}
			}

			return {
				showModal, hideModal, showDealerModal, hideDealerModal
			}
		},

		data() {
			return {
				
                modal_title: "Update Work Status",
				button_title: "Update",

				keyword: "",
				showsearch: false,
				listing_length: 10,

				token: "",
				errors: {},
				activate: false,
         		deactivate: false,

         		active_page_url: null,

                status_type: "",

                vendor_id: "",
                vendors: [],
                material_id: "",
                cost: "",
                remarks: "",
                payment_status: "",
                payment_type: "",
                payment_date: "",
                online_amount: "",
                cash_amount: "",
                payment_id: "",
                payment_by: "",
                payment_user_id: "",
                bank_account_id: "",
                amount_from_credit: "",
                deduct_from_credit: false,
                paymentDealerSearch: "",
                showPaymentDealerSuggestions: false,
                selectedPaymentDealer: null,
                companies: [],
                paymentCustomerSearch: "",
                showPaymentCustomerSuggestions: false,
                selectedPaymentCustomer: null,
                banks: [],
                userCredit: null,
                userCreditLoading: false,
                userCreditError: "",
                prevShowUserCredit: false,

                service:{},
                work_logs: [],

               
                
                // ICCID Search Data
                iccid_search: '',
                selectedIccid: null,
                showIccidSuggestions: false,
                filteredIccidList: [],
                continue_with_current_iccid: false,
                sim_change_status: 1,
                sim_change_remarks: '',
                current_sim_iccid: '',
                certificate_validity: '',

                // Replace Device Data
                current_device_imei: '',
                disallocatedDevices: [],
                filteredDisallocatedDevices: [],
                newImeiSearch: '',
                newImeiSearchTimer: null,
                selectedNewImei: null,
                showNewImeiSuggestions: false,
                replace_device_remarks: '',
                
                // Component Update - Materials Data
                rawMaterials: [],
                componentMaterials: [],
                isSubmitting: false,
                
                // Dealer assignment properties
                dealer_modal_title: "Assign to Dealer",
                selected_dealer_id: "",
                dealers: [],
                
			};
		},
        created(){
            this.complaintDetails();
            this.fetchDealers();
            this.fetchCompanies();
            this.fetchBankAccounts();
        },

		computed: {
			filteredPaymentDealers() {
				if (!this.paymentDealerSearch || !this.paymentDealerSearch.trim()) return this.dealers;
				const q = this.paymentDealerSearch.toLowerCase();
				return this.dealers.filter(d => (d.first_name || '').toLowerCase().includes(q));
			},
			filteredPaymentCustomers() {
				if (!this.paymentCustomerSearch || !this.paymentCustomerSearch.trim()) return this.companies;
				const q = this.paymentCustomerSearch.toLowerCase();
				return this.companies.filter(c => (c.company_name || '').toLowerCase().includes(q));
			},
			/** Credit / deduct-from-credit fields (aligned with recharge.vue) */
			showCompletedPaymentCredit() {
				if (this.status_type !== '4' || !this.payment_user_id) return false;
				if (this.payment_status === '5') return true;
				if (this.payment_status === '2' && this.deduct_from_credit) return true;
				if (this.payment_status === '1' && this.payment_type === '4') return true;
				return false;
			},
		},

		watch: {
			payment_user_id: 'maybeFetchCompletePaymentCredit',
			payment_status: 'maybeFetchCompletePaymentCredit',
			deduct_from_credit: 'maybeFetchCompletePaymentCredit',
			payment_type: 'maybeFetchCompletePaymentCredit',
		},

        methods: {

			getSelectedUserId(entity) {
				return entity && entity.user_id ? String(entity.user_id) : '';
			},

            getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

            complaintDetails(page_url = null) {
				this.getToken();
				let url = '/staffs/serviceDetail?service_id=' + this.$route.params.id;
				page_url = page_url || url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.service = responseData.service || {};
                        this.work_logs = responseData.work_logs || [];
					})
					.catch((err) => console.log(err));
			},

            fetchVendors() {
                this.getToken();

                this.$axios
                    .get('/staffs/vendorsList', {
                        headers: { Authorization: "Bearer " + this.token }
                    })
                    .then((res) => {
                        if (res.data.status === true || res.data.status === 'true') {
                            this.vendors = res.data.data;
                        } else {
                            this.vendors = [];
                            this.$swal('Error', res.data.message || 'Failed to load vendors', 'error');
                        }
                    })
                    .catch((err) => {
                        console.error('Error fetching vendors:', err);
                        this.vendors = [];
                    });
            },

            onStatusTypeChange() {
                if (this.status_type === '2') {
                    this.fetchVendors();
                } else if (this.status_type === '1') {
                    // Initialize component materials with one empty row
                    this.componentMaterials = [{
                        search: '',
                        selectedMaterial: null,
                        qty: 1,
                        showSuggestions: false,
                        filteredList: []
                    }];
                    this.fetchRawMaterials();
                } else if (this.status_type === '3') {
                    this.sim_change_status = 1;
                    this.continue_with_current_iccid = false;
                    this.current_sim_iccid = this.service?.device?.iccid || this.service?.iccid || '';
                    this.certificate_validity = this.service?.certificate_validity != null && this.service?.certificate_validity !== '' ? String(this.service.certificate_validity) : '';
                    this.sim_change_remarks = this.service?.sim_change_remarks || '';
                    this.iccid_search = "";
                    this.selectedIccid = null;
                    this.showIccidSuggestions = false;
                    this.filteredIccidList = [];
                } else if (this.status_type === '4') {
                    this.initCompletedPaymentFromService();
                } else if (this.status_type === '5') {
                    this.current_device_imei = this.service?.device?.imei || this.service?.imei || '';
                    this.clearNewImeiSelection();
                    this.replace_device_remarks = '';
                    this.fetchDisallocatedDevices();
                }
            },

            initCompletedPaymentFromService() {
                this.payment_by = '1';
                this.payment_status = '';
                this.payment_type = '';
                this.payment_date = '';
                this.payment_user_id = '';
                this.bank_account_id = '';
                this.amount_from_credit = '';
                this.deduct_from_credit = false;
                this.online_amount = '';
                this.cash_amount = '';
                this.payment_id = '';
                this.selectedPaymentCustomer = null;
                this.paymentCustomerSearch = '';
                this.selectedPaymentDealer = null;
                this.paymentDealerSearch = '';
                this.userCredit = null;
                this.userCreditError = '';
                this.prevShowUserCredit = false;

                const dealerId = this.service?.dealer_id != null ? this.service.dealer_id : null;
                if (dealerId != null) {
                    // service.dealer_id is dealers.user_id (users.id), not dealers.id
                    const dealer = this.dealers.find(
                        (d) => d.user_id == dealerId || String(d.user_id) === String(dealerId)
                    );
                    if (dealer) {
                        this.selectedPaymentDealer = dealer;
                        this.paymentDealerSearch = dealer.first_name || '';
                        this.payment_user_id = this.getSelectedUserId(dealer);
                    } else {
                        this.paymentDealerSearch = this.service?.dealer_name || '';
                        this.selectedPaymentDealer = {
                            id: dealerId,
                            first_name: this.service?.dealer_name || '',
                            user_id: dealerId,
                        };
                        this.payment_user_id = String(dealerId);
                    }
                }
            },

            fetchCompanies() {
                this.getToken();
                this.$axios
                    .get('/staffs/companies', { headers: { Authorization: 'Bearer ' + this.token } })
                    .then((res) => {
                        const data = res.data.data || res.data;
                        this.companies = Array.isArray(data) ? data : (data.data || []);
                    })
                    .catch(() => {
                        this.companies = [];
                    });
            },

            fetchBankAccounts() {
                this.getToken();
                this.$axios
                    .get('/staffs/bankAccounts', { headers: { Authorization: 'Bearer ' + this.token } })
                    .then((res) => {
                        const data = res.data.data || res.data;
                        this.banks = Array.isArray(data) ? data : (data.data || []);
                    })
                    .catch(() => {
                        this.banks = [];
                    });
            },

            todayIsoDate() {
                const d = new Date();
                const y = d.getFullYear();
                const m = String(d.getMonth() + 1).padStart(2, "0");
                const day = String(d.getDate()).padStart(2, "0");
                return `${y}-${m}-${day}`;
            },

            onCompletedPaymentStatusChange() {
                if (this.payment_status === '4') {
                    this.payment_by = '';
                    this.payment_user_id = '';
                    this.payment_type = '';
                    this.payment_date = '';
                    this.bank_account_id = '';
                    this.amount_from_credit = '';
                    this.deduct_from_credit = false;
                    this.selectedPaymentDealer = null;
                    this.selectedPaymentCustomer = null;
                    this.paymentDealerSearch = '';
                    this.paymentCustomerSearch = '';
                    return;
                }
                if (this.payment_status === '1') {
                    if (!this.payment_date) {
                        this.payment_date = this.todayIsoDate();
                    }
                } else {
                    this.payment_date = '';
                }
                if (this.payment_status !== '1') {
                    this.payment_type = '';
                    this.bank_account_id = '';
                    this.online_amount = '';
                    this.cash_amount = '';
                    this.payment_id = '';
                }
                if (this.payment_status !== '2') {
                    this.deduct_from_credit = false;
                }
                const useCredit =
                    this.payment_status === '5' ||
                    (this.payment_status === '2' && this.deduct_from_credit) ||
                    (this.payment_status === '1' && this.payment_type === '4');
                if (!useCredit) {
                    this.amount_from_credit = '';
                }
            },

            onCompletedPaymentByChange() {
                this.payment_user_id = '';
                this.payment_type = '';
                this.bank_account_id = '';
                this.amount_from_credit = '';
                this.deduct_from_credit = false;
                this.selectedPaymentDealer = null;
                this.selectedPaymentCustomer = null;
                this.paymentDealerSearch = '';
                this.paymentCustomerSearch = '';

                if (this.payment_by === '1' && this.service?.dealer_id != null) {
                    const dealerId = this.service.dealer_id;
                    // service.dealer_id is dealers.user_id (users.id), not dealers.id
                    const dealer = this.dealers.find(
                        (d) => d.user_id == dealerId || String(d.user_id) === String(dealerId)
                    );
                    if (dealer) {
                        this.selectedPaymentDealer = dealer;
                        this.paymentDealerSearch = dealer.first_name || '';
                        this.payment_user_id = this.getSelectedUserId(dealer);
                    } else {
                        this.paymentDealerSearch = this.service?.dealer_name || '';
                        this.selectedPaymentDealer = {
                            id: dealerId,
                            first_name: this.service?.dealer_name || '',
                            user_id: dealerId,
                        };
                        this.payment_user_id = String(dealerId);
                    }
                }
            },

            onCompletedPaymentTypeChange() {
                if (this.payment_type === '2') {
                    this.cash_amount = '';
                } else if (this.payment_type === '1') {
                    this.online_amount = '';
                    this.payment_id = '';
                } else if (this.payment_type === '4') {
                    this.online_amount = '';
                    this.cash_amount = '';
                    this.payment_id = '';
                }
                if (!(this.payment_type === '2' || this.payment_type === '3')) {
                    this.bank_account_id = '';
                }
            },

            async maybeFetchCompletePaymentCredit() {
                if (this.status_type !== '4') return;
                const nowVisible = this.showCompletedPaymentCredit;
                const wasVisible = this.prevShowUserCredit;

                if (!nowVisible) {
                    this.userCredit = null;
                    this.userCreditError = '';
                    this.userCreditLoading = false;
                    this.amount_from_credit = '';
                    this.prevShowUserCredit = nowVisible;
                    return;
                }
                if (!this.payment_user_id) return;

                if (!wasVisible) {
                    this.amount_from_credit = this.cost || '';
                }

                await this.fetchCompletePaymentUserCredit();
                this.prevShowUserCredit = nowVisible;
            },

            async fetchCompletePaymentUserCredit() {
                try {
                    this.getToken();
                    this.userCreditLoading = true;
                    this.userCreditError = '';

                    const response = await this.$axios.get('/staffs/getUserCredit', {
                        params: { user_id: this.payment_user_id },
                        headers: { Authorization: 'Bearer ' + this.token },
                    });

                    const ok = response.data?.status === true || response.data?.status === 'true';
                    if (!ok) {
                        this.userCredit = null;
                        this.userCreditError = response.data?.message || 'Failed to fetch credit balance';
                        return;
                    }

                    this.userCredit = response.data?.data?.user_credit || null;
                } catch (e) {
                    this.userCredit = null;
                    this.userCreditError = e?.response?.data?.message || 'Failed to fetch credit balance';
                } finally {
                    this.userCreditLoading = false;
                }
            },

            searchPaymentDealer() {
                this.showPaymentDealerSuggestions = true;
            },
            hidePaymentDealerSuggestions() {
                setTimeout(() => {
                    this.showPaymentDealerSuggestions = false;
                }, 200);
            },
            selectPaymentDealer(dealer) {
                const userId = this.getSelectedUserId(dealer);
                if (!userId) {
                    this.$swal('Error', 'Selected dealer has no linked user account', 'error');
                    return;
                }
                this.selectedPaymentDealer = dealer;
                this.paymentDealerSearch = dealer.first_name;
                this.showPaymentDealerSuggestions = false;
                this.payment_user_id = userId;
            },

            searchPaymentCustomer() {
                this.showPaymentCustomerSuggestions = true;
            },
            hidePaymentCustomerSuggestions() {
                setTimeout(() => {
                    this.showPaymentCustomerSuggestions = false;
                }, 200);
            },
            selectPaymentCustomer(cust) {
                this.selectedPaymentCustomer = cust;
                this.paymentCustomerSearch = cust.company_name;
                this.showPaymentCustomerSuggestions = false;
                this.payment_user_id = this.getSelectedUserId(cust);
            },
            
            fetchRawMaterials() {
                this.getToken();
                this.$axios
                    .get("/staffs/getRawMaterials", { 
                        headers: { Authorization: "Bearer " + this.token } 
                    })
                    .then((res) => {
                        if (res.data.status === true || res.data.status === 'true') {
                            this.rawMaterials = res.data.data || [];
                        } else {
                            this.rawMaterials = [];
                            this.$swal('Error', res.data.message || 'Failed to load materials', 'error');
                        }
                    })
                    .catch((err) => {
                        console.error('Error fetching raw materials:', err);
                        this.rawMaterials = [];
                        this.$swal('Error', 'Failed to load materials', 'error');
                    });
            },
            
            searchMaterial(index) {
                const material = this.componentMaterials[index];
                if (!material.search || material.search.trim() === '') {
                    material.filteredList = [];
                    return;
                }
                
                const searchTerm = material.search.toLowerCase();
                material.filteredList = this.rawMaterials.filter(mat => {
                    const name = (mat.raw_material_name || '').toLowerCase();
                    const desc = (mat.description || '').toLowerCase();
                    return name.includes(searchTerm) || desc.includes(searchTerm);
                });
            },
            
            selectMaterial(index, mat) {
                const material = this.componentMaterials[index];
                material.search = mat.raw_material_name;
                material.selectedMaterial = mat;
                material.showSuggestions = false;
                material.filteredList = [];
            },
            
            hideMaterialSuggestions(index) {
                setTimeout(() => {
                    this.componentMaterials[index].showSuggestions = false;
                }, 200);
            },
            
            addMaterial() {
                this.componentMaterials.push({
                    search: '',
                    selectedMaterial: null,
                    qty: 1,
                    showSuggestions: false,
                    filteredList: []
                });
            },
            
            removeMaterial(index) {
                if (this.componentMaterials.length > 1) {
                    this.componentMaterials.splice(index, 1);
                }
            },

            openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},

            updateStatus() {
                this.errors = {};
				this.modal_title = "Update Work Status";
				this.button_title = "Update";
                this.clearForm();
				this.showModal();
            },

            clearForm() {
                this.status_type = "";
                this.vendor_id = "";
                this.material_id = "";
                this.iccid_search = "";
                this.selectedIccid = null;
                this.showIccidSuggestions = false;
                this.filteredIccidList = [];
                this.continue_with_current_iccid = false;
                this.sim_change_status = 1;
                this.current_sim_iccid = '';
                this.sim_change_remarks = '';
                this.certificate_validity = '';
                this.current_device_imei = '';
                this.clearNewImeiSelection();
                this.replace_device_remarks = '';
                this.cost = "";
                this.remarks = "";
                this.payment_status = "";
                this.payment_type = "";
                this.online_amount = "";
                this.cash_amount = "";
                this.payment_id = "";
                this.payment_by = "";
                this.payment_user_id = "";
                this.bank_account_id = "";
                this.amount_from_credit = "";
                this.deduct_from_credit = false;
                this.paymentDealerSearch = "";
                this.selectedPaymentDealer = null;
                this.paymentCustomerSearch = "";
                this.selectedPaymentCustomer = null;
                this.userCredit = null;
                this.userCreditError = "";
                this.prevShowUserCredit = false;
                this.componentMaterials = [];
                this.isSubmitting = false;
            },

            onContinueCurrentIccidChange() {
                this.sim_change_status = this.continue_with_current_iccid ? 2 : 1;
                if (this.sim_change_status === 2) {
                    this.iccid_search = "";
                    this.selectedIccid = null;
                    this.showIccidSuggestions = false;
                    this.filteredIccidList = [];
                }
            },

            searchIccid() {
                if (this.iccid_search.trim() === '') {
                    this.filteredIccidList = [];
                    return;
                }

                this.getToken();

                this.$axios.get('/staffs/fetchICCID', {
                    params: { iccid: this.iccid_search },
                    headers: { Authorization: `Bearer ${this.token}` }
                })
                .then((res) => {
                    if (res.data.status === 'true') {
                        this.filteredIccidList = res.data.data; // Populate ICCID suggestions
                    } else {
                        this.filteredIccidList = [];
                    }
                })
                .catch((err) => {
                    console.error('Error fetching ICCIDs:', err);
                    this.filteredIccidList = [];
                });
            },


            selectIccid(iccid) {
                this.iccid_search = iccid.iccid;
                this.showIccidSuggestions = false;

                this.getToken();

                this.$axios.get('/staffs/getSimByICCID', {
                    params: { iccid: iccid.iccid },
                    headers: { Authorization: `Bearer ${this.token}` },
                })
                .then((res) => {
                    if (res.data.status === 'true') {
                        this.selectedIccid = res.data.data;
                        // Example: auto-fill related fields
                        this.sim_1 = this.selectedIccid.sim_1;
                        this.sim_2 = this.selectedIccid.sim_2;
                    } else {
                        this.selectedIccid = null;
                        this.$swal('Error', res.data.message || 'No SIM details found', 'error');
                    }
                })
                .catch((err) => {
                    console.error('Error fetching SIM details:', err);
                    this.selectedIccid = null;
                });
            },

            hideIccidSuggestions() {
                setTimeout(() => {
                    this.showIccidSuggestions = false;
                }, 200);
            },

            clearNewImeiSelection() {
                this.newImeiSearch = '';
                this.selectedNewImei = null;
                this.filteredDisallocatedDevices = [];
                this.showNewImeiSuggestions = false;
                if (this.newImeiSearchTimer) {
                    clearTimeout(this.newImeiSearchTimer);
                    this.newImeiSearchTimer = null;
                }
            },

            fetchDisallocatedDevices() {
                this.getToken();
                const dealerId = this.service?.dealer_id;
                if (dealerId == null || dealerId === '') {
                    this.disallocatedDevices = [];
                    this.$swal('Error', 'Dealer not found on this service', 'error');
                    return Promise.resolve([]);
                }
                return this.$axios
                    .get('/staffs/fetchDealerDisallocatedDevices', {
                        headers: { Authorization: 'Bearer ' + this.token },
                        params: { dealer_id: dealerId },
                    })
                    .then((res) => {
                        if (res.data.status === 'true' || res.data.status === true) {
                            this.disallocatedDevices = Array.isArray(res.data.data) ? res.data.data : [];
                        } else {
                            this.disallocatedDevices = [];
                        }
                        return this.disallocatedDevices;
                    })
                    .catch((err) => {
                        console.error('Error fetching dealer disallocated devices:', err);
                        this.disallocatedDevices = [];
                        const msg = err?.response?.data?.message;
                        this.$swal(
                            'Error',
                            typeof msg === 'string' ? msg : 'Failed to load disallocated devices',
                            'error'
                        );
                        return [];
                    });
            },

            onNewImeiFocus() {
                this.showNewImeiSuggestions = true;
                if (!this.disallocatedDevices.length) {
                    this.fetchDisallocatedDevices();
                }
            },

            searchNewImei() {
                if (this.selectedNewImei && String(this.newImeiSearch).trim() !== String(this.selectedNewImei.imei)) {
                    this.selectedNewImei = null;
                }
                if (this.newImeiSearchTimer) clearTimeout(this.newImeiSearchTimer);
                if (!this.newImeiSearch.trim()) {
                    this.filteredDisallocatedDevices = [];
                    return;
                }
                this.newImeiSearchTimer = setTimeout(() => {
                    const q = this.newImeiSearch.trim().toLowerCase();
                    if (!q) {
                        this.filteredDisallocatedDevices = [];
                        this.newImeiSearchTimer = null;
                        return;
                    }
                    this.filteredDisallocatedDevices = this.disallocatedDevices
                        .filter((d) => {
                            const imei = (d.imei || '').toLowerCase();
                            const iccid = (d.iccid || '').toLowerCase();
                            return imei.includes(q) || iccid.includes(q);
                        })
                        .slice(0, 50);
                    this.newImeiSearchTimer = null;
                }, 200);
            },

            selectNewImei(device) {
                this.selectedNewImei = device;
                this.newImeiSearch = device.imei || '';
                this.showNewImeiSuggestions = false;
                this.filteredDisallocatedDevices = [];
            },

            hideNewImeiSuggestions() {
                setTimeout(() => {
                    this.showNewImeiSuggestions = false;
                }, 200);
            },

            /** Informational breakdown only (aligned with recharge.vue — no strict match validation). */
            getPaymentBreakdown() {
                if (this.status_type !== '4' || this.payment_status !== '1' || !this.payment_type || this.payment_type === '4') {
                    return null;
                }

                const total = parseFloat(this.cost) || 0;
                const online = parseFloat(this.online_amount) || 0;
                const cash = parseFloat(this.cash_amount) || 0;

                let paid = 0;
                if (this.payment_type === '2') {
                    paid = online;
                } else if (this.payment_type === '1') {
                    paid = cash;
                } else if (this.payment_type === '3') {
                    paid = online + cash;
                } else {
                    return null;
                }

                const eps = 0.01;
                const diff = paid - total;
                let statusLabel = 'Partial';
                let statusClass = 'text-warning';
                if (Math.abs(diff) < eps) {
                    statusLabel = 'Full';
                    statusClass = 'text-success';
                } else if (diff > eps) {
                    statusLabel = 'Advance';
                    statusClass = 'text-info';
                }

                return {
                    total,
                    online,
                    cash,
                    statusLabel,
                    statusClass,
                };
            },

            submitStatusUpdate() {
                // Prevent double submission
                if (this.isSubmitting) {
                    return;
                }
                
                if (!this.status_type) {
                    this.$swal('Error', 'Please select a status type', 'error');
                    return;
                }

                // Status-specific validations
                if (this.status_type === '1') { // Component Update
                    if (!this.componentMaterials || this.componentMaterials.length === 0) {
                        this.$swal('Error', 'Please add at least one material', 'error');
                        return;
                    }
                    
                    // Validate each material
                    for (let i = 0; i < this.componentMaterials.length; i++) {
                        const mat = this.componentMaterials[i];
                        if (!mat.selectedMaterial) {
                            this.$swal('Error', `Please select material for row ${i + 1}`, 'error');
                            return;
                        }
                        if (!mat.qty || mat.qty < 1) {
                            this.$swal('Error', `Please enter valid quantity for row ${i + 1}`, 'error');
                            return;
                        }
                    }
                }

                if (this.status_type === '2') { // To Manufacturer
                    if (!this.vendor_id) {
                        this.$swal('Error', 'Please select vendor', 'error');
                        return;
                    }
                }

                if (this.status_type === '3') { // SIM Change
                    if (!this.certificate_validity) {
                        this.$swal('Error', 'Please select year of expiry', 'error');
                        return;
                    }

                    if (this.sim_change_status === 1 && !this.selectedIccid) {
                        this.$swal('Error', 'Please select ICCID', 'error');
                        return;
                    }

                    if (this.sim_change_status === 2 && !this.sim_change_remarks.trim()) {
                        this.$swal('Error', 'Please enter remarks', 'error');
                        return;
                    }
                }

                if (this.status_type === '5') { // Replace device
                    if (!this.selectedNewImei || !this.selectedNewImei.imei) {
                        this.$swal('Error', 'Please select a new IMEI', 'error');
                        return;
                    }
                }

                if (this.status_type === '4') { // Completed (recharge-style payment flow)
                    if (!this.payment_status) {
                        this.$swal('Error', 'Please select payment status', 'error');
                        return;
                    }

                    if (this.payment_status !== '4') {
                        if (this.cost === '' || this.cost === null || this.cost === undefined) {
                            this.$swal('Error', 'Please enter total amount', 'error');
                            return;
                        }
                        if (!String(this.remarks || '').trim()) {
                            this.$swal('Error', 'Please enter remarks', 'error');
                            return;
                        }
                        if (!this.payment_by) {
                            this.$swal('Error', 'Please select payment by (dealer or customer)', 'error');
                            return;
                        }
                        if (!this.payment_user_id) {
                            this.$swal('Error', 'Please select who paid (dealer or customer)', 'error');
                            return;
                        }
                    }

                    if (this.payment_status !== '4' && this.payment_status === '1') {
                        if (!this.payment_date) {
                            this.$swal('Error', 'Please select payment date', 'error');
                            return;
                        }
                        if (!this.payment_type) {
                            this.$swal('Error', 'Please select payment type', 'error');
                            return;
                        }
                        if (this.payment_type === '2') {
                            if (!this.online_amount || parseFloat(this.online_amount) <= 0) {
                                this.$swal('Error', 'Please enter online amount', 'error');
                                return;
                            }
                            if (!this.bank_account_id) {
                                this.$swal('Error', 'Please select bank', 'error');
                                return;
                            }
                            if (!String(this.payment_id || '').trim()) {
                                this.$swal('Error', 'Please enter payment ID', 'error');
                                return;
                            }
                        } else if (this.payment_type === '1') {
                            if (!this.cash_amount || parseFloat(this.cash_amount) <= 0) {
                                this.$swal('Error', 'Please enter cash amount', 'error');
                                return;
                            }
                        } else if (this.payment_type === '3') {
                            if (!this.online_amount || parseFloat(this.online_amount) <= 0) {
                                this.$swal('Error', 'Please enter online amount', 'error');
                                return;
                            }
                            if (!this.cash_amount || parseFloat(this.cash_amount) <= 0) {
                                this.$swal('Error', 'Please enter cash amount', 'error');
                                return;
                            }
                            if (!this.bank_account_id) {
                                this.$swal('Error', 'Please select bank', 'error');
                                return;
                            }
                            if (!String(this.payment_id || '').trim()) {
                                this.$swal('Error', 'Please enter payment ID', 'error');
                                return;
                            }
                        } else if (this.payment_type === '4') {
                            const ca = parseFloat(this.amount_from_credit);
                            if (!this.amount_from_credit || isNaN(ca) || ca <= 0) {
                                this.$swal('Error', 'Please enter amount from credit', 'error');
                                return;
                            }
                        }
                    }

                    if (this.showCompletedPaymentCredit) {
                        const ca = parseFloat(this.amount_from_credit);
                        if (!this.amount_from_credit || isNaN(ca) || ca <= 0) {
                            this.$swal('Error', 'Please enter amount from credit', 'error');
                            return;
                        }
                        if (this.userCredit && this.userCredit.credit_available_amount != null) {
                            const avail = parseFloat(this.userCredit.credit_available_amount);
                            if (!isNaN(avail) && ca > avail) {
                                this.$swal('Error', 'Amount from credit cannot exceed available credit', 'error');
                                return;
                            }
                        }
                        const cap = parseFloat(this.cost) || 0;
                        if (!isNaN(cap) && ca > cap) {
                            this.$swal('Error', 'Amount from credit cannot exceed total amount', 'error');
                            return;
                        }
                    }
                }

            
                let apiUrl = '';
                let payload = { service_id: this.service.id };

                switch(this.status_type) {
                    case '1': // Component Update
                        apiUrl = '/staffs/componentReplacement';
                        payload.raw_materials = this.componentMaterials.map(mat => ({
                            raw_material_id: mat.selectedMaterial.id,
                            qty: mat.qty
                        }));
                        break;
                    case '2': // To Manufacturer
                        apiUrl = '/staffs/assignToVendor';
                        payload.vendor_id = this.vendor_id;
                        break;
                    case '3': // SIM Change
                        apiUrl = '/staffs/updateDeviceSimDetails';
                        payload.sim_change_status = this.sim_change_status;
                        payload.iccid = this.sim_change_status === 1 ? this.selectedIccid.iccid : '';
                        payload.imei = this.service.device.imei;
                        payload.primary_number = this.sim_change_status === 1 ? (this.selectedIccid.msisdn_1 || '') : '';
                        payload.secondary_number = this.sim_change_status === 1 ? (this.selectedIccid.msisdn_2 || '') : '';
                        payload.network_provider = this.sim_change_status === 1 ? (this.selectedIccid.sim || '') : '';
                        payload.certificate_validity = this.certificate_validity || '';
                        payload.remarks = this.sim_change_remarks ? this.sim_change_remarks.trim() : '';
                        break;
                    case '5': // Replace device
                        apiUrl = '/staffs/replaceServiceDevice';
                        payload.new_imei = this.selectedNewImei.imei;
                        payload.remarks = this.replace_device_remarks ? this.replace_device_remarks.trim() : '';
                        break;
                    case '4': // Completed
                        apiUrl = '/staffs/completeWorkStatus';
                        payload.total_amount = this.payment_status === '4' ? 0 : this.cost;
                        payload.payment_status = this.payment_status;
                        payload.remarks = this.remarks || '';
                        if (this.payment_status !== '4') {
                            payload.payment_user_type = this.payment_by;
                            payload.payment_user_id = this.payment_user_id;
                            payload.deduct_from_credit =
                                this.payment_status === '5'
                                    ? 1
                                    : (this.payment_status === '2' ? (this.deduct_from_credit ? 1 : 2) : 2);
                            payload.amount_from_credit = this.showCompletedPaymentCredit
                                ? (parseFloat(this.amount_from_credit) || 0)
                                : 0;
                            payload.bank_account_id = '';
                            if (this.payment_status === '1') {
                                payload.payment_date = this.payment_date;
                                payload.payment_type = this.payment_type;
                                if (this.payment_type === '2' || this.payment_type === '3') {
                                    payload.bank_account_id = this.bank_account_id;
                                    payload.cash_online = this.online_amount;
                                    payload.payment_id = this.payment_id;
                                }
                                if (this.payment_type === '1' || this.payment_type === '3') {
                                    payload.cash_in_hand = this.cash_amount;
                                }
                            }
                        }
                        break;
                    default:
                        this.$swal('Error', 'Invalid status type', 'error');
                        return;
                }

                // --- Make API request ---
                this.isSubmitting = true;
                this.getToken();
                this.$axios.post(apiUrl, payload, { headers: { Authorization: "Bearer " + this.token } })
                    .then(res => {
                        this.isSubmitting = false;
                        this.$swal('Success', res.data.message || 'Status updated successfully', 'success');
                        this.closeModal();
                        this.complaintDetails(); // Refresh details
                    })
                    .catch(err => {
                        this.isSubmitting = false;
                        console.error(err);
                        this.$swal('Error', err.response?.data?.message || 'Failed to update status', 'error');
                    });
            },

            fetchDealers() {
                this.getToken();
                this.$axios
                    .get("/staffs/dealers", { headers: { Authorization: "Bearer " + this.token } })
                    .then((res) => {
                        var responseData = res.data;
                        this.dealers = responseData.data;
                    })
                    .catch((err) => console.log(err));
            },

            assignToDealer() {
                this.selected_dealer_id = this.service.dealer_id || "";
                this.dealer_modal_title = `Assign to Dealer - Service #${this.service.id}`;
                this.showDealerModal();
            },

            closeDealerModal() {
                this.hideDealerModal();
                this.selected_dealer_id = "";
            },

            submitDealerAssignment() {
                if (!this.selected_dealer_id) {
                    this.$swal('Error', 'Please select a dealer', 'error');
                    return;
                }

                if (!this.service.id) {
                    this.$swal('Error', 'No service selected', 'error');
                    return;
                }

                this.getToken();
                const config = {
                    headers: {
                        'Authorization': 'Bearer ' + this.token,
                    }
                };

                this.$axios
                    .post('/staffs/assignToDealer', {
                        service_id: this.service.id,
                        dealer_id: this.selected_dealer_id
                    }, config)
                    .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                title: 'Success!',
                                text: response.data.message || 'Service assigned to dealer successfully',
                                icon: 'success',
                                timer: 3000,
                                showConfirmButton: false,
                                toast: true,
                                position: 'top-end'
                            });
                            this.closeDealerModal();
                            this.complaintDetails();
                        } else {
                            this.$swal('Error', response.data.message || 'Failed to assign dealer', 'error');
                        }
                    })
                    .catch(error => {
                        if (error.response && error.response.data && error.response.data.message) {
                            this.$swal('Error', error.response.data.message, 'error');
                        } else {
                            this.$swal('Error', 'Something went wrong', 'error');
                        }
                    });
            },

            
        }

   }


</script>